module.exports = __webpack_public_path__ + "static/bruceSite-bd547cbcd59c9716323b39d696d6e277.png";